import styled from 'styled-components';
import { themeSpacing, getThemeZIndex } from '@dbh/styled-helpers';

// `getNavbarHeightFromProps` from @dbh/navbar to avoid a circular dependency.
const TappableSecretZone=/*#__PURE__*/styled.div.withConfig({componentId:"sc-1mny955-0"})(["top:",";position:absolute;right:",";width:",";height:",";z-index:",";"],a=>themeSpacing(a,a.top),a=>themeSpacing(a,a.right),a=>themeSpacing(a,a.width),a=>themeSpacing(a,a.height),getThemeZIndex(["header","tappableSecretZone"]));TappableSecretZone.displayName="TappableSecretZone",TappableSecretZone.defaultProps={right:"0",top:"sp11",width:"sp14",height:"sp14"};

export { TappableSecretZone as default };
